(function($, undefined) {
	"use strict";
	
	let utils;

	function init() {
		utils = Fw.component.models().utils;
		$('.duplicate-gendata-btn').on('click', duplicateGenData);
	}

	function duplicateGenData({ currentTarget }) {
		const { id,type } = currentTarget.dataset;
		
		utils.duplicateGenData(id, [], type,() => {
			window.location.reload(true);
		});
	}
	
	$(init);
	
})(jQuery);